import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Formatear fechas
export function formatDate(date: string | Date | null): string {
    if (!date) return "-";
    const dateStr = typeof date === 'string' ? date.split('T')[0] : date.toISOString().split('T')[0];
    const d = new Date(`${dateStr}T12:00:00`);
    return d.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}

// Formatear hora
export function formatTime(date: string | Date): string {
    const d = new Date(date);
    return d.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit'
    });
}

// Formatear fecha y hora
export function formatDateTime(date: string | Date): string {
    const d = typeof date === 'string' && !date.includes('T') ? new Date(`${date}T12:00:00`) : new Date(date);
    return d.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

// Formatear moneda
export function formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN'
    }).format(amount);
}

// Obtener color de estado de orden de trabajo
export function getStatusColor(status: string): string {
    const colors: Record<string, string> = {
        'ABIERTA': 'bg-green-100 text-green-800',
        'EN_PROGRESO': 'bg-yellow-100 text-yellow-800',
        'PAUSADA': 'bg-orange-100 text-orange-800',
        'CERRADA': 'bg-blue-100 text-blue-800',
        'CANCELADA': 'bg-red-100 text-red-800',
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
}

// Obtener label de estado
export function getStatusLabel(status: string): string {
    const labels: Record<string, string> = {
        'ABIERTA': 'Abierta',
        'EN_PROGRESO': 'En Progreso',
        'PAUSADA': 'Pausada',
        'CERRADA': 'Cerrada',
        'CANCELADA': 'Cancelada',
    };
    return labels[status] || status;
}

// Obtener color de prioridad
export function getPriorityColor(priority: string): string {
    const colors: Record<string, string> = {
        'BAJA': 'bg-gray-100 text-gray-800',
        'MEDIA': 'bg-blue-100 text-blue-800',
        'ALTA': 'bg-orange-100 text-orange-800',
        'URGENTE': 'bg-red-100 text-red-800',
    };
    return colors[priority] || 'bg-gray-100 text-gray-800';
}
